import { APIENDPOINT } from "../services/apiHelper";
import dummyImage from "../assets/dummyImage.jpg";
import { useEffect, useState } from "react";

export const mediaSource = (input) => {
  if (typeof input === "string" && input) {
    return `${APIENDPOINT}${input}`;
  }
  if (input?.currentTarget) {
    input.currentTarget.onerror = null;
    input.currentTarget.src = dummyImage;
    return dummyImage;
  }
  return dummyImage;
};

export const useBackgroundImage = (fileUrl) => {
  const [bgUrl, setBgUrl] = useState(dummyImage);

  useEffect(() => {
    if (!fileUrl) {
      setBgUrl(dummyImage);
      return;
    }
    const url = mediaSource(fileUrl);
    const img = new Image();
    img.src = url;

    img.onload = () => setBgUrl(url);
    img.onerror = () => setBgUrl(dummyImage);
  }, [fileUrl]);

  return bgUrl;
};

export const isVideo = (fileName) => {
  if (typeof fileName === "string" && fileName?.split(".")?.[1]?.includes("mp4")) return true;
  return false;
};
